import type { Diagnostic, ProjectStore } from "./store";

export class DiagnosticsPane {
  readonly root: HTMLElement;

  private body: HTMLElement;

  constructor(private store: ProjectStore) {
    this.root = document.createElement("div");
    this.root.classList.add("card", "shadow", "overflow-y-hidden");
    this.root.setAttribute("style", "height: 20rem;");
    this.root.innerHTML = `
            <div class="card-header">
                Qualitätsreport
            </div>
            <div id="body">
            </div>
        `;

    this.body = this.root.querySelector("#body")!;

    this.store.addEventListener("diagnostics", this.update);

    this.hide();
    this.update();
  }

  public detach() {
    this.store.removeEventListener("diagnostics", this.update);
  }

  private update = () => {
    this.body.innerHTML = `
            <div class="list-group list-group-flush">
            <div>
        `;

    const list = this.body.querySelector("div")!;

    for (const diagnostic of this.store.diagnostics) {
      list.appendChild(renderItem(this.store, diagnostic));
    }
  };

  public toggle() {
    if (this.root.classList.contains("d-none")) {
      this.show();
    } else {
      this.hide();
    }
  }

  public hide() {
    this.root.classList.add("d-none");
  }

  public show() {
    this.root.classList.remove("d-none");
  }
}

function renderItem(store: ProjectStore, diagnostic: Diagnostic): HTMLElement {
  const element = document.createElement("a");
  element.classList.add(
    "list-group-item",
    "list-group-item-action",
    "border-bottom",
  );
  element.setAttribute("href", "#");
  element.innerHTML = `
                ${diagnostic.element}: ${diagnostic.message}
            `;

  if (diagnostic.type === "warning") {
    element.classList.add("list-group-item-warning");
  } else {
    element.classList.add("list-group-item-danger");
  }

  element.addEventListener("click", (event) => {
    event.preventDefault();
    store.setActiveElement(diagnostic.element);
  });

  return element;
}
